import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";
import { guideSignals } from "@/lib/guideSignals";

interface ExcerptCreate {
  text: string;
  page_number?: number;
}

interface ExcerptResponse {
  chunk_id: string;
  text: string;
  section: string;
}

export function useAddExcerpt(conceptId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      paperId,
      data,
    }: {
      paperId: string;
      data: ExcerptCreate;
    }) =>
      apiClient
        .post(
          `api/concepts/${conceptId}/papers/${paperId}/excerpts`,
          { json: data },
        )
        .json<ExcerptResponse>(),
    onSuccess: () => {
      guideSignals.mark(conceptId, 'hasExcerpts');
      queryClient.invalidateQueries({
        queryKey: ["index-status", conceptId],
      });
    },
  });
}
